import styles from './ExperimentFastTrackGoogleApplication.module.scss'
import { Button, Spacer, Typography } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import { useExperiment, SignUpReason, teamIcedLatteExperiments } from '@percent/cause-dashboard/common/hooks'
import { useNavigate } from 'react-router-dom'
import { getSignUpUrl } from '@percent/cause-dashboard/common/utility/utility'

interface ExperimentFastTrackGoogleApplicationProps {
  partnerId: string
  userLanguage: string
  organizationId?: string
}

export const ExperimentFastTrackGoogleApplication = ({
  partnerId,
  userLanguage,
  organizationId
}: ExperimentFastTrackGoogleApplicationProps) => {
  const { t } = useTranslation()
  const fastTrackGoogleApplicationExperiment = useExperiment(
    teamIcedLatteExperiments.fastTrackGoogleApplication,
    partnerId
  )
  const navigate = useNavigate()

  const handleExperimentCtaClick = () => {
    fastTrackGoogleApplicationExperiment.trackEventOnceThisSession('clickCta')
    const url = getSignUpUrl({
      organizationId,
      signUpReason: SignUpReason.VERIFICATION_SUPPORT,
      signUpPartnerId: partnerId
    })
    navigate(url)
  }

  if (
    !fastTrackGoogleApplicationExperiment.canPerformExperiment ||
    !organizationId ||
    !userLanguage.toLowerCase().includes('en')
  ) {
    return null
  }

  return (
    <div className={styles.ctaContainer} data-testid="google-fast-track-experiment">
      <Typography variant="default">{t('typography.googleApplication.title')}</Typography>
      <Spacer size={2} axis="vertical" />
      <div className={`${styles.ctaFlex} ${styles.ctaText}`}>{t('typography.googleApplication.body')}</div>
      <Spacer size={4} axis="vertical" />
      <div className={styles.ctaFlex}>
        <Button size="large" data-testid="sign-up-btn" stretch onClick={handleExperimentCtaClick}>
          {t('typography.experiments.ctaButton')}
        </Button>
      </div>
    </div>
  )
}
